// extracted by mini-css-extract-plugin
module.exports = {"container":"_ffede98","skeleton":"_52e0598","textSkeleton":"_9b7e347","dropdownSection":"_e5f60e5","title":"_9cfc151"};